import { render, staticRenderFns } from "./section.vue?vue&type=template&id=1adc80c4&scoped=true"
import script from "./section.vue?vue&type=script&lang=js"
export * from "./section.vue?vue&type=script&lang=js"
import style0 from "./section.vue?vue&type=style&index=0&id=1adc80c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc80c4",
  null
  
)

export default component.exports